/** Shared Customers Grid border overlap helpers (server-safe — no "use client"). */

export function customersGridRowFromIndex(
  index: number,
  columns: number
): number {
  return Math.floor(index / columns);
}

/**
 * Horizontal border dedup aligned with vertical `-ml-px` overlap:
 * - Rows after the first pull up with `-mt-px`
 * - Non-last rows drop `border-b` so the row below's top border draws the seam
 *   (avoids the upper row's bottom border being covered by the lower cell fill)
 */
export function customersGridRowBorderClass(
  row: number,
  totalRows: number
): string | undefined {
  const classes: string[] = [];

  if (row > 0) {
    classes.push("-mt-px");
  }
  if (row < totalRows - 1) {
    classes.push("border-b-0");
  }

  return classes.length > 0 ? classes.join(" ") : undefined;
}

export function customersGridColumnFromIndex(
  index: number,
  columns: number
): number {
  return index % columns;
}

export function getExpandDirection(
  row: number,
  totalRows: number
): "down" | "up" {
  return row < totalRows - 1 ? "down" : "up";
}

/**
 * Bottom-row cells overlap horizontally via `-ml-px`; later columns paint on top
 * and cover earlier cells' bottom-right rounded corners. Raise z-index for
 * earlier columns on the last row so outer corner radii stay visible.
 */
export function customersGridLastRowStackZIndex(
  row: number,
  column: number,
  totalRows: number,
  columns: number
): number | undefined {
  if (row !== totalRows - 1) {
    return undefined;
  }

  return columns - column;
}
